import { useState, type FormEvent } from "react";
import { getUploaderName } from "../../lib/uploaderName.js";

interface PasswordFormProps {
  title: string;
  onSubmit: (password: string, name: string) => void;
  submitting: boolean;
  error: string | null;
}

export function PasswordForm({ title, onSubmit, submitting, error }: PasswordFormProps) {
  const [name, setName] = useState(() => getUploaderName() ?? "");
  const [password, setPassword] = useState("");

  function handleSubmit(evt: FormEvent) {
    evt.preventDefault();
    if (password.trim().length === 0 || name.trim().length === 0) return;
    onSubmit(password, name.trim());
  }

  return (
    <div className="center-screen">
      <form className="card stack" style={{ maxWidth: 380, width: "100%" }} onSubmit={handleSubmit}>
        <h1>{title}</h1>
        <div className="field">
          <label htmlFor="guest-name">Ton prénom</label>
          <input
            id="guest-name"
            className="input"
            type="text"
            autoComplete="given-name"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Camille"
            maxLength={60}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Mot de passe</label>
          <input
            id="password"
            className="input"
            type="password"
            inputMode="text"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>
        {error && <p className="error-text">{error}</p>}
        <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
          {submitting ? "Vérification…" : "Entrer"}
        </button>
      </form>
    </div>
  );
}
